import React, { Component } from "react";
import Sidebar from "react-sidebar";

export default class CoaSideBarMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: props.sidebarOpen
    }
  }

  render() {
    const { sidebarOpen } = this.state;

    return (
      <Sidebar
        sidebar={sidebarOpen && <div>Show me something</div>}
        open={sidebarOpen}
        onSetOpen={() => this.toggleSidebar(!sidebarOpen)}
        styles={{
          sidebar: {
            background: "white",
            color: "black",
            zIndex: 2000,
            minWidth: 200,
          }
        }}
      >
        <b>Main content</b>
      </Sidebar>
);
  }
}


// WEBPACK FOOTER //
// ./src/components/CoaSideBarMenu.js